import React from "react";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import T from "prop-types";
import { Button, Col, Row } from "react-bootstrap";
import { reduxForm, Field, FieldArray } from "redux-form";
import { Body, Footer } from "MODULES/shared/components/Modal";
import { Check, CheckGroup, FormInput } from "MODULES/shared/components/Forms";
import * as actions from "MODULES/RepairOrders/actions";
import { PAID_IN_FULL } from "MODULES/SalesOrders/constants";
import { AMOUNT_PAID } from "MODULES/PurchaseOrders/constants";
import { properCase, toSentence } from "LIB/formatters/text";
import {
  REPAIR_EVALUATION_APPROVED,
  REPAIR_EVALUATION_REJECTED
} from "MODULES/RepairOrders/constants";
import moment from "moment";
import { withFieldAccessors } from "MODULES/shared/decorators/withFieldAccessors";
import CurrencyField from "../../../../shared/components/Forms/CurrencyField";

class Form extends React.Component {
  setToFullVal = () => {
    this.props.repairOrder.line_items
      .filter(l => !l.cancelled)
      .forEach((l, idx) => {
        this.props.change(
          `line_items[${idx}].${AMOUNT_PAID}`,
          Number(this.fieldAmount(l))
        );

        this.props.change(`line_items[${idx}].${PAID_IN_FULL}`, true);
        this.setInvoicePaidDate(idx);
      });
  };

  setItemToFullVal = idx => {
    const lineItem = this.props.repairOrder.line_items.filter(
      l => !l.cancelled
    )[idx];
    this.props.change(
      `line_items[${idx}].${AMOUNT_PAID}`,
      Number(this.fieldAmount(lineItem))
    );
  };

  setInvoicePaidDate = idx => {
    const date = moment().format("YYYY-MM-DD");
    if (!this.props.getFieldValue(`line_items[${idx}].invoice_paid_date`)) {
      this.props.change(`line_items[${idx}].invoice_paid_date`, date);
    }
  };

  fieldAmount = lineItem => {
    if (lineItem.approval_status === REPAIR_EVALUATION_APPROVED) {
      return [
        lineItem.part_cost,
        lineItem.labor_cost,
        lineItem.outside_labor_cost
      ].reduce((partialSum, a) => partialSum + Number(a), 0);
    } else if (lineItem.approval_status === REPAIR_EVALUATION_REJECTED) {
      return Number(lineItem.evaluation_charge);
    }

    return 0;
  };

  handleTopLevelFormChange = (ev, field) => {
    const val = ev.target.value;
    this.props.repairOrder.line_items.forEach((l, idx) => {
      this.props.change(`line_items[${idx}].${field}`, val);
    });
  };

  renderLineItems = ({ fields }) => (
    <tbody>
      {fields.map((item, idx) => (
        <tr>
          <td>
            <div className="row row-col-gutters-half">
              <Col md={2}>
                <Field
                  component={FormInput}
                  name={`${item}.part.part_number`}
                  label="Part #"
                  disabled
                />
              </Col>
              <Col md={2}>
                <Field
                  component={FormInput}
                  name={`${item}.serial_number`}
                  label="Serial #"
                  disabled
                />
              </Col>
              <Col md={2}>
                <Field
                  component={FormInput}
                  name={`${item}.invoice_number`}
                  label="Invoice Number"
                />
              </Col>
              <Col md={2}>
                <Field
                  component={FormInput}
                  name={`${item}.invoice_date`}
                  label="Invoice Date"
                  type="date"
                />
              </Col>
              <Col md={2}>
                <Field
                  component={FormInput}
                  name={`${item}.invoice_due_date`}
                  label="Invoice Due Date"
                  type="date"
                />
              </Col>
              <Col md={2}>
                <Field
                  component={FormInput}
                  name={`${item}.invoice_paid_date`}
                  label="Invoice Paid Date"
                  type="date"
                />
              </Col>
              <Col md={2}>
                <Field
                  component={CurrencyField}
                  name={[item, AMOUNT_PAID].join(".")}
                  label={properCase(AMOUNT_PAID)}
                />
              </Col>
              <Col md={1}>
                <CheckGroup justified title="In Full">
                  <Field
                    name={`${item}.${PAID_IN_FULL}`}
                    component={Check}
                    label="Yes"
                    onChange={() => {
                      this.setItemToFullVal(idx);
                      this.setInvoicePaidDate(idx);
                    }}
                  />
                </CheckGroup>
              </Col>
            </div>
          </td>
        </tr>
      ))}
    </tbody>
  );

  render() {
    const {
      repairOrder,
      handleSubmit,
      close,
      invalid,
      submitting
    } = this.props;
    const activeLineItems = repairOrder.line_items.filter(l => !l.cancelled);
    const shouldRenderSection = activeLineItems.length > 1;

    return (
      <form onSubmit={handleSubmit}>
        <Body>
          {shouldRenderSection && (
            <Row className="row-col-gutters-half">
              <Col md={2}>
                <Field
                  component={FormInput}
                  name="invoice_number"
                  label="Invoice Number"
                  onChange={e =>
                    this.handleTopLevelFormChange(e, "invoice_number")}
                />
              </Col>
              <Col md={2}>
                <Field
                  component={FormInput}
                  name="invoice_date"
                  label="Invoice Date"
                  type="date"
                  onChange={e =>
                    this.handleTopLevelFormChange(e, "invoice_date")}
                />
              </Col>
              <Col md={2}>
                <Field
                  component={FormInput}
                  name="invoice_due_date"
                  label="Invoice Due Date"
                  type="date"
                  onChange={e =>
                    this.handleTopLevelFormChange(e, "invoice_due_date")}
                />
              </Col>
              <Col md={2}>
                <Field
                  component={FormInput}
                  name="invoice_paid_date"
                  label="Invoice Paid Date"
                  type="date"
                  onChange={e =>
                    this.handleTopLevelFormChange(e, "invoice_paid_date")}
                />
              </Col>
              <Col md={2}>
                <CheckGroup justified title="Amt Paid In Full">
                  <Field
                    name={PAID_IN_FULL}
                    component={Check}
                    label="Yes"
                    onChange={this.setToFullVal}
                  />
                </CheckGroup>
              </Col>
            </Row>
          )}
          <table className="table table-striped table-numbered margin-bottom-none">
            <FieldArray
              name="line_items"
              component={this.renderLineItems}
              lineItems={repairOrder.line_items}
            />
          </table>
        </Body>
        <Footer>
          <Button onClick={close}>Cancel</Button>
          <Button
            type="submit"
            bsStyle="primary"
            disabled={invalid || submitting}
          >
            &nbsp;Update Invoice Details
          </Button>
        </Footer>
      </form>
    );
  }
}

Form.propTypes = {
  change: T.func.isRequired,
  close: T.func.isRequired,
  handleSubmit: T.func.isRequired,
  invalid: T.bool.isRequired,
  repairOrder: T.shape({}),
  submitting: T.bool.isRequired
};

export default connect(undefined, (dispatch, ownProps) => ({
  onSubmit: data => {
    dispatch(actions.bulkUpdateLineItems(data))
      .then(() => {
        ownProps.close();
      })
      .catch(error => {
        if (error.errors) {
          const errorMessage = Object.keys(error.errors)
            .map(key => {
              const messages = error.errors[key];
              return `${properCase(key)} ${toSentence(messages)}.`;
            })
            .join(". ");

          toastr.error("Error", errorMessage);
        } else {
          toastr.error("Error", error.message);
        }
      });
  }
}))(
  reduxForm({
    form: "editInvoiceDetails"
  })(withFieldAccessors(Form))
);



// WEBPACK FOOTER //
// ./app/modules/RepairOrders/components/Detail/EditInvoiceDetails/Form.jsx